export default __webpack_public_path__ + "static/media/LegacyLogo.5b4fdb1b.png";